<template>
    <app-content class="h-panel">
        <div class="h-panel-bar"><span class="h-panel-title">个税申报</span></div>
        <div class="tabs-bar">
            <span v-for="t in tabs" :key="t.key" :class="{active: tab===t.key}" @click="tab=t.key">{{t.title}}</span>
        </div>
        <div v-if="tab==='declare'" class="tab-body">
            <div class="margin-top margin-left filter-bar">
                <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
                <span class="label">至</span>
                <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
                <input type="text" v-model="keyword" placeholder="姓名/证件号码" class="input-small" @keyup.enter="loadList">
                <Button size="s" @click="loadList">刷新</Button>
                <span class="flex-spacer"></span>
                <Button color="primary" size="s" @click="add">新增</Button>
                <Button size="s" @click="batchCompute">个税算税</Button>
                <Button size="s" @click="batchDeclare">个税申报</Button>
                <Button size="s" @click="showTaxAccount=true">税务账号设置</Button>
            </div>
            <div class="h-panel-body">
                <div class="table-wrap">
                    <table class="grid">
                        <thead>
                        <tr>
                            <th>姓名</th>
                            <th>证件类型</th>
                            <th>证件号码</th>
                            <th class="num">当期收入额</th>
                            <th class="num">当期免税收入</th>
                            <th class="num">基本养老保险</th>
                            <th class="num">基本医疗保险</th>
                            <th class="num">失业保险</th>
                            <th class="num">住房公积金</th>
                            <th class="num">累计子女教育支出</th>
                            <th class="num">累计继续教育支出</th>
                            <th class="num">累计房屋贷款支出</th>
                            <th class="num">累计住房租金支出</th>
                            <th class="num">累计赡养老人支出</th>
                            <th class="num">累计3岁以下婴幼儿照护支出</th>
                            <th class="num">累计个人养老金</th>
                            <th class="num">年金</th>
                            <th class="num">商业健康保险</th>
                            <th class="num">税延养老保险</th>
                            <th class="num">其他</th>
                            <th class="num">准予扣除的捐赠额</th>
                            <th class="num">减免税额</th>
                            <th class="num">减除费用</th>
                            <th>备注</th>
                            <th>所得项目名称</th>
                            <th class="num">累计收入额</th>
                            <th class="num">累计免税收入额</th>
                            <th class="num">累计减除费用额</th>
                            <th class="num">累计准予扣除的捐赠额</th>
                            <th class="num">累计应纳税所得额</th>
                            <th class="num">税率</th>
                            <th class="num">速算扣除数</th>
                            <th class="num">累计应纳税额</th>
                            <th class="num">累计减免税额</th>
                            <th class="num">累计应扣缴税额</th>
                            <th class="num">已缴税额</th>
                            <th class="num">应补退税额</th>
                            <th style="width:90px">操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in datas" :key="item.id">
                            <td>{{item.name}}</td>
                            <td>{{item.idType}}</td>
                            <td>{{item.idNumber}}</td>
                            <td class="num">{{item.currentIncome|numFormat}}</td>
                            <td class="num">{{item.currentTaxFree|numFormat}}</td>
                            <td class="num">{{item.pension|numFormat}}</td>
                            <td class="num">{{item.medical|numFormat}}</td>
                            <td class="num">{{item.unemployment|numFormat}}</td>
                            <td class="num">{{item.housingFund|numFormat}}</td>
                            <td class="num">{{item.childEdu|numFormat}}</td>
                            <td class="num">{{item.continueEdu|numFormat}}</td>
                            <td class="num">{{item.housingLoan|numFormat}}</td>
                            <td class="num">{{item.housingRent|numFormat}}</td>
                            <td class="num">{{item.elderly|numFormat}}</td>
                            <td class="num">{{item.infantCare|numFormat}}</td>
                            <td class="num">{{item.personalPension|numFormat}}</td>
                            <td class="num">{{item.annuity|numFormat}}</td>
                            <td class="num">{{item.commercialHealth|numFormat}}</td>
                            <td class="num">{{item.taxDeferred|numFormat}}</td>
                            <td class="num">{{item.other|numFormat}}</td>
                            <td class="num">{{item.donation|numFormat}}</td>
                            <td class="num">{{item.taxReduction|numFormat}}</td>
                            <td class="num">{{item.deductionFee|numFormat}}</td>
                            <td>{{item.remark}}</td>
                            <td>{{item.incomeName}}</td>
                            <td class="num">{{item.cumIncome|numFormat}}</td>
                            <td class="num">{{item.cumTaxFree|numFormat}}</td>
                            <td class="num">{{item.cumDeduction|numFormat}}</td>
                            <td class="num">{{item.cumDonation|numFormat}}</td>
                            <td class="num">{{item.cumTaxable|numFormat}}</td>
                            <td class="num">{{item.taxRate|numFormat}}</td>
                            <td class="num">{{item.quickDeduction|numFormat}}</td>
                            <td class="num">{{item.cumTax|numFormat}}</td>
                            <td class="num">{{item.cumTaxReduction|numFormat}}</td>
                            <td class="num">{{item.cumWithhold|numFormat}}</td>
                            <td class="num">{{item.paidTax|numFormat}}</td>
                            <td class="num strong">{{item.taxDue|numFormat}}</td>
                            <td class="actions"><span @click="edit(item)">编辑</span><span @click="remove(item)">删除</span></td>
                        </tr>
                        <tr v-if="!datas.length"><td :colspan="38" class="text-center padding">暂无数据</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="tab-body">
            <div class="h-panel-body text-center padding">
                {{tabs.find(t=>t.key===tab).title}}：该页面暂未开放完整功能
            </div>
        </div>

        <Modal v-model="showForm" hasCloseIcon>
            <div slot="header">{{form.id?'编辑个税申报':'新增个税申报'}}</div>
            <div class="form-scroll">
                <div class="sec-title">基本信息</div>
                <div class="form-grid3">
                    <div class="f-item"><label class="req">姓名</label><input type="text" v-model="form.name"></div>
                    <div class="f-item"><label>证件类型</label><Select v-model="form.idType" :datas="idTypeOptions" :deletable="true"></Select></div>
                    <div class="f-item"><label>证件号码</label><input type="text" v-model="form.idNumber"></div>
                    <div class="f-item"><label>所得项目</label><input type="text" v-model="form.incomeName"></div>
                    <div class="f-item"><label>申报期间</label><input type="text" v-model="form.period" placeholder="yyyy-MM"></div>
                    <div class="f-item"><label>备注</label><input type="text" v-model="form.remark"></div>
                </div>
                <div class="sec-title">收入与扣除</div>
                <div class="form-grid3">
                    <div class="f-item"><label>当期收入额</label><NumberInput v-model="form.currentIncome" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>当期免税收入</label><NumberInput v-model="form.currentTaxFree" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>减除费用</label><NumberInput v-model="form.deduction" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>基本养老保险</label><NumberInput v-model="form.pension" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>基本医疗保险</label><NumberInput v-model="form.medical" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>失业保险</label><NumberInput v-model="form.unemployment" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>住房公积金</label><NumberInput v-model="form.housingFund" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>年金</label><NumberInput v-model="form.annuity" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>商业健康保险</label><NumberInput v-model="form.commercialHealth" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>税延养老保险</label><NumberInput v-model="form.taxDeferred" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>其他</label><NumberInput v-model="form.other" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>准予扣除捐赠</label><NumberInput v-model="form.donation" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>减免税额</label><NumberInput v-model="form.taxReduction" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>已缴税额</label><NumberInput v-model="form.paidTax" :precision="2" @change="calc"></NumberInput></div>
                </div>
                <div class="sec-title">专项附加扣除（累计）</div>
                <div class="form-grid3">
                    <div class="f-item"><label>累计子女教育</label><NumberInput v-model="form.childEdu" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>累计继续教育</label><NumberInput v-model="form.continueEdu" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>累计房屋贷款</label><NumberInput v-model="form.housingLoan" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>累计住房租金</label><NumberInput v-model="form.housingRent" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>累计赡养老人</label><NumberInput v-model="form.elderly" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>3岁以下照护</label><NumberInput v-model="form.infantCare" :precision="2" @change="calc"></NumberInput></div>
                    <div class="f-item"><label>累计个人养老金</label><NumberInput v-model="form.personalPension" :precision="2" @change="calc"></NumberInput></div>
                </div>
                <div class="sec-title">计算结果</div>
                <div class="form-grid3 result">
                    <div class="f-item"><label>累计收入额</label><NumberInput v-model="form.cumIncome" :precision="2" readonly></NumberInput></div>
                    <div class="f-item"><label>累计应纳税所得额</label><NumberInput v-model="form.cumTaxable" :precision="2" readonly></NumberInput></div>
                    <div class="f-item"><label>税率</label><NumberInput v-model="form.taxRate" :precision="4" readonly></NumberInput></div>
                    <div class="f-item"><label>速算扣除数</label><NumberInput v-model="form.quickDeduction" :precision="2" readonly></NumberInput></div>
                    <div class="f-item"><label>累计应纳税额</label><NumberInput v-model="form.cumTax" :precision="2" readonly></NumberInput></div>
                    <div class="f-item"><label>累计应扣缴税额</label><NumberInput v-model="form.cumWithhold" :precision="2" readonly></NumberInput></div>
                    <div class="f-item"><label>应补退税额</label><NumberInput v-model="form.taxDue" :precision="2" readonly></NumberInput></div>
                </div>
            </div>
            <div class="drawer-footer">
                <Button @click="showForm=false">取消</Button>
                <Button color="primary" @click="save" :loading="loading">保存</Button>
            </div>
        </Modal>

        <Modal v-model="showTaxAccount" hasCloseIcon>
            <div slot="header">税务账号设置</div>
            <Form v-width="420" :labelWidth="110">
                <FormItem label="纳税人识别号"><input type="text" v-model="taxAccount.taxpayerId"></FormItem>
                <FormItem label="企业名称"><input type="text" v-model="taxAccount.companyName"></FormItem>
                <FormItem label="登录账号"><input type="text" v-model="taxAccount.account"></FormItem>
                <FormItem label="登录密码"><input type="password" v-model="taxAccount.password"></FormItem>
                <FormItem label="税务局"><input type="text" v-model="taxAccount.taxBureau"></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button @click="showTaxAccount=false">取消</Button>
                <Button color="primary" @click="saveTaxAccount" :loading="loading">保存</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
const defaultDeclare = {
    id: null, name: '', idType: '居民身份证', idNumber: '', period: '', remark: '', incomeName: '工资薪金所得',
    currentIncome: 0, currentTaxFree: 0, deduction: 5000,
    pension: 0, medical: 0, unemployment: 0, housingFund: 0,
    annuity: 0, commercialHealth: 0, taxDeferred: 0, other: 0, donation: 0, taxReduction: 0, paidTax: 0,
    childEdu: 0, continueEdu: 0, housingLoan: 0, housingRent: 0, elderly: 0, infantCare: 0, personalPension: 0,
    cumIncome: 0, cumTaxFree: 0, cumDeduction: 0, cumDonation: 0, cumTaxable: 0,
    taxRate: 0, quickDeduction: 0, cumTax: 0, cumTaxReduction: 0, cumWithhold: 0, taxDue: 0
};
export default {
    name: 'SalaryTaxDeclare',
    data() {
        return {
            tab: 'declare',
            tabs: [
                { key: 'declare', title: '个税申报' },
                { key: 'records', title: '个税申报记录' },
                { key: 'company', title: '单位申报记录查询' },
                { key: 'personal', title: '个人扣缴明细查询' },
                { key: 'payment', title: '缴税记录查询' }
            ],
            datas: [], p1: this.curYm(), p2: this.curYm(), keyword: '',
            showForm: false, loading: false, form: JSON.parse(JSON.stringify(defaultDeclare)),
            showTaxAccount: false, taxAccount: { taxpayerId: '', companyName: '', account: '', password: '', taxBureau: '' },
            idTypeOptions: ['居民身份证', '护照', '港澳居民来往内地通行证', '台湾居民来往大陆通行证', '外国人永久居留身份证']
        };
    },
    methods: {
        curYm() { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}`; },
        fmtPeriod(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; },
        loadList() {
            this.$api.salary.tax.list({
                p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2),
                keyword: this.keyword || undefined
            }).then(({ data }) => { this.datas = data || []; });
        },
        add() { this.form = JSON.parse(JSON.stringify(defaultDeclare)); this.form.period = this.curYm(); this.showForm = true; },
        edit(item) {
            this.$api.salary.tax.load(item.id).then(({ data }) => {
                this.form = Object.assign(JSON.parse(JSON.stringify(defaultDeclare)), data || {});
                this.showForm = true;
            });
        },
        remove(item) {
            this.$Confirm('确认删除?').then(() => {
                this.$api.salary.tax.delete(item.id).then(() => { this.loadList(); this.$Message.success('已删除'); });
            });
        },
        calc() {
            // 简化累计计算：累计收入 = 当期收入，累计减除 = 减除费用
            this.form.cumIncome = Number(this.form.currentIncome || 0);
            this.form.cumTaxFree = Number(this.form.currentTaxFree || 0);
            this.form.cumDeduction = Number(this.form.deduction || 0);
            this.form.cumDonation = Number(this.form.donation || 0);
            const social = Number(this.form.pension || 0) + Number(this.form.medical || 0) + Number(this.form.unemployment || 0) + Number(this.form.housingFund || 0);
            const special = Number(this.form.childEdu || 0) + Number(this.form.continueEdu || 0) + Number(this.form.housingLoan || 0)
                + Number(this.form.housingRent || 0) + Number(this.form.elderly || 0) + Number(this.form.infantCare || 0)
                + Number(this.form.personalPension || 0);
            const otherDed = Number(this.form.annuity || 0) + Number(this.form.commercialHealth || 0) + Number(this.form.taxDeferred || 0) + Number(this.form.other || 0);
            this.form.cumTaxable = Math.max(0, this.form.cumIncome - this.form.cumTaxFree - this.form.cumDeduction - social - special - otherDed - this.form.cumDonation);
            // 年度个税累进税率（简化按单月累计处理）
            const x = this.form.cumTaxable;
            let rate = 0, qd = 0;
            if (x <= 0) { rate = 0; qd = 0; }
            else if (x <= 36000) { rate = 0.03; qd = 0; }
            else if (x <= 144000) { rate = 0.10; qd = 2520; }
            else if (x <= 300000) { rate = 0.20; qd = 16920; }
            else if (x <= 420000) { rate = 0.25; qd = 31920; }
            else if (x <= 660000) { rate = 0.30; qd = 52920; }
            else if (x <= 960000) { rate = 0.35; qd = 85920; }
            else { rate = 0.45; qd = 181920; }
            this.form.taxRate = rate;
            this.form.quickDeduction = qd;
            this.form.cumTax = Number((x * rate - qd).toFixed(2));
            this.form.cumTaxReduction = Number(this.form.taxReduction || 0);
            this.form.cumWithhold = Math.max(0, this.form.cumTax - this.form.cumTaxReduction);
            this.form.taxDue = Number((this.form.cumWithhold - Number(this.form.paidTax || 0)).toFixed(2));
        },
        save() {
            if (!this.form.name) { this.$Message.error('请填写姓名'); return; }
            this.calc();
            const p = Object.assign({}, this.form);
            this.loading = true;
            this.$api.salary.tax[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false; this.showForm = false; this.loadList(); this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        batchCompute() { this.$Message.info('个税算税：请选中记录后单条计算'); },
        batchDeclare() { this.$Message.info('个税申报：需对接税务局接口，当前为本地演示'); },
        saveTaxAccount() {
            this.loading = true;
            this.$api.salary.tax.taxAccount(this.taxAccount).then(({ msg }) => {
                this.loading = false; this.showTaxAccount = false; this.$Message.success(msg || '已保存');
            }).catch(() => { this.loading = false; });
        }
    },
    mounted() { this.loadList(); }
};
</script>

<style scoped lang="less">
.tabs-bar { display: flex; border-bottom: 1px solid #e2e2e2; background: #fafafa; padding: 0 16px;
    span { padding: 10px 18px; cursor: pointer; font-size: 13px; color: #666; border-bottom: 2px solid transparent; }
    span.active { color: #3b91ff; border-bottom-color: #3b91ff; background: #fff; }
}
.tab-body { background: #fff; }
.filter-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 150px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}
.table-wrap { overflow-x: auto; }
.grid { width: auto; min-width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    .num { text-align: right; }
    .strong { font-weight: bold; color: #e23c3c; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
}
.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.form-scroll { padding: 10px 16px 70px; max-height: calc(100vh - 160px); overflow-y: auto; }
.sec-title { font-weight: bold; font-size: 14px; margin: 14px 0 10px; padding-left: 8px; border-left: 3px solid #3b91ff; }
.form-grid3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px 16px; margin-bottom: 10px;
    .f-item { display: flex; align-items: center;
        label { width: 130px; flex-shrink: 0; text-align: right; margin-right: 8px; font-size: 12px; }
        label.req::before { content: '*'; color: #e23c3c; margin-right: 2px; }
        input, .h-select, .h-numberinput, .h-datepicker { flex: 1; min-width: 0; }
        input { height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 6px; }
    }
}
.form-grid3.result .f-item label { color: #333; font-weight: bold; }
.drawer-footer { position: absolute; bottom: 0; left: 0; right: 0; padding: 12px 16px; background: #fff; border-top: 1px solid #e8e8e8; text-align: center; }
</style>
